<nb-layout>
	<nb-layout-header fixed>
		<app-header class="header"></app-header>
	</nb-layout-header>

	<nb-layout-column>
		<router-outlet></router-outlet>
	</nb-layout-column>

	<nb-layout-footer fixed>
		<app-footer class="footer"></app-footer>
	</nb-layout-footer>
</nb-layout>
